module.exports = __webpack_public_path__ + "static/media/investment.0181a27f.svg";